export const original = {
    body: '#f2e5d7',
    textColor: '#FFF'

}

export const invert = {
    body: '#262322',
    textColor: '#F2E5D7'
}

